// JamBase image URLs are behind Cloudflare bot protection (hotlink block), so
// they must be served through a proxy. Soundcharts and other hosts are left
// untouched. wsrv.nl is a free, reliable public image proxy.

const JAMBASE_IMAGE = /^https:\/\/(www\.|images\.)?jambase\.com\//i;
const PROXY = 'https://wsrv.nl/?url=';

export function proxifyImage(url) {
  if (!url) return url;
  const s = String(url);
  if (JAMBASE_IMAGE.test(s)) return PROXY + encodeURIComponent(s);
  return s;
}

export default proxifyImage;
